import { FC, useEffect, useState } from "react";

import { Button, IconButton, Stack, TextField } from "@mui/material";

import DeleteIcon from '@mui/icons-material/Delete';

import { uuidv4 } from "../../../../../utils";
import { ImageNameToGroup } from "./ReportImageGrouping";
import ImageSubNameComponent from "./ImageSubNameComponent";

interface ImageGroupComponentProps {
    group: ImageNameToGroup;
    deleteGroupItem: () => void;
}

const ImageGroupComponent: FC<ImageGroupComponentProps> = ({ group, deleteGroupItem }) => {
    const [groupName, setGroupName] = useState<string>("");

    const [imageSubnames, setImageSubnames] = useState<string[]>([]);

    useEffect(() => {
        setGroupName(group.groupName);
        setImageSubnames(group.imageSubnames);
    }, [group]);

    function GroupNameChanged(event: any) {
        var value = event.target.value;
        setGroupName(value);
        group.groupName = value;
    }

    function AddSubname() {
        const newArray = [...imageSubnames, ""];
        setImageSubnames(newArray);
        group.imageSubnames = newArray;
    }

    function DeleteItem(index: number) {
        imageSubnames.splice(index, 1);
        const newArray = [...imageSubnames];
        setImageSubnames(newArray);
        group.imageSubnames = newArray;
    }

    return (
        <Stack
            direction={"column"}
            justifyContent="center"
            alignItems="flex-start"
            sx={{ border: "2px solid orange", padding: "2px" }}>

            {/* Group name */}
            <Stack
                direction={"row"}
                alignItems={"center"}>
                <span>Group name: </span>
                <TextField
                    value={groupName}
                    onChange={GroupNameChanged}
                    sx={{ minWidth: "245px", marginLeft: "10px" }}
                    size="small" />

                <IconButton
                    color="error"
                    onClick={() => deleteGroupItem()}>
                    <DeleteIcon />
                </IconButton>
            </Stack>

            {/* Image subnames */}
            {imageSubnames.map((_, index) =>
                <ImageSubNameComponent
                    key={uuidv4()}
                    array={imageSubnames}
                    arrayIndex={index}
                    deleteItem={DeleteItem} />
            )}

            <Button
                variant="outlined"
                onClick={AddSubname}
                sx={{ width: "180px", marginTop: "5px" }}>
                Add subname
            </Button>
        </Stack >
    )
}

export default ImageGroupComponent;